import parse, { domToReact } from 'html-react-parser';
import Typography from "@mui/material/Typography"
import Link from "next/link";

const ParseHtml = ({html}) => {
    
    const sort = (html) => {
        if(!html) return;
        const options = {
            replace: (domNode) => {
                const {children, attribs, name, data } = domNode
                if(name){
                    if(name == 'a'){
                        return (
                            <>
                            <Link href={attribs.href} className={attribs.class}>{children[0].data}</Link>
                            </>
                        )
                    }
                    else if(name == 'br'){
                        return <br/>
                    }
                    else {
                        const attributes = {
                            className: attribs.class,
                            component: name,
                            variant: name,
                            color: attribs.color
                        }
                        if(attribs.variant) {
                            attributes.variant = attribs.variant;
                        }
                        return (
                            <Typography {...attributes}>
                                {domToReact(children, options)}
                            </Typography>
                        );
                    }
                }
                if(!name && data){
                    return (
                        <>
                            {data}
                        </>
                    )
                }
            }
        };
        return parse(html, options)
    }


  return <>{sort(html)}</>;
}

export default ParseHtml